import UserRoles from 'constants/UserRoles';

export function isAccountOwnerLogin(rootState) {
	if (!rootState) {
		return false;
	}

	const user = rootState.user;
	return user == null || user === '';
}

export function isAccountManager(rootState) {
	if (!rootState) {
		return false;
	}

	if (rootState.isAdmin) {
		return true;
	}

	if (rootState.user == null) {
		return true;
	}

	const role = parseInt(rootState.roles, 10);
	if (Number.isNaN(role)) {
		return false;
	}

	return role <= UserRoles.Manager;
}
